export default __webpack_public_path__ + "static/media/Metakey_A01.132cfd47.mp4";